import { useMemo } from "react";
import { Paper, Stack, Text, Title } from "@mantine/core";
import type { LegacyReportReviewState } from "../../../types/legacyReportReview";
import LegacyDocumentContent from "../legacy-cases/LegacyDocumentContent";

export default function LegacyReportOriginal({
  source,
}: {
  source: LegacyReportReviewState["source"];
}) {
  const document = useMemo(
    () => ({
      id: source.documentId,
      kind: "report" as const,
      originalFileName: source.fileName,
      mimeType: "application/pdf",
      byteLength: 0,
      sha256: source.sha256,
      contentUrl: source.contentUrl,
    }),
    [source]
  );
  return (
    <Paper withBorder p="md">
      <Stack gap="sm">
        <Title order={2}>Original NovoPath report</Title>
        <Text size="sm" c="dimmed">
          Preserved source document · {source.fileName}
        </Text>
        <LegacyDocumentContent key={source.documentId} document={document} />
      </Stack>
    </Paper>
  );
}
